<!--单位信息模块-->
<template>
  <div class="unitInfoBody">
    <div class="topLeftTitleContent">基本信息</div>
    <div class="unitContent bodyBorder" style="display: flex;align-items: center;justify-content:space-between;">
      <div style="width: 392px;">
        <columnsContent class="columnsContent" img="unitInfo_1" columns="地址" :content="nowUnit.address">
        </columnsContent>
        <columnsContent class="columnsContent" img="unitInfo_2" columns="联系人" :content="nowUnit.leader">
        </columnsContent>
        <columnsContent class="columnsContent" img="unitInfo_3" columns="接入时间"
          :content="new Date(nowUnit.joinTime).formatByTime('-')"></columnsContent>

        <columnsContent class="columnsContent toExport" img="unitInfo_4" columns="运维报告" content="点击导出上月运维报告"
          @onClick="exportReport" v-if="showExport"></columnsContent>
      </div>
      <div class="userInfo" style="display: none">
        <div>
          <span>{{kanbanCountInfo.user}}</span>
          <span style="color: white;font-size:.14rem;">总用户数</span>
          <p></p>
        </div>
        <div>
          <span>{{kanbanCountInfo.device}}</span>
          <span style="color: white;font-size: .14rem;">总设备数</span>
          <p></p>
        </div>
        <div>
          <span>{{kanbanCountInfo.monitoringPoint}}</span>
          <span style="color: white;font-size: .14rem;">总监测点数</span>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import columnsContent from '@/page/unitKanBan/component/columnsContent.vue'
  export default {
    components: {
      columnsContent,
    },
    props: [],
    data () {
      return {
        kanbanCountInfo: {
          device: 0,
          monitoringPoint: 0,
          user: 0,
        }
      }
    },
    created () {},
    mounted () {
      this.$api.entityApi.getUnitBoardRanking(null,1651117635000,null,'day','process',res => {
        console.log(res,9090909090);
      })
      this.initData()
    },
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      showExport () {
        //看看是不是应该显示导出运维报告
        return this.$router.currentRoute.path!='/temperatureOverView'
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
    },
    watch: {
      nowUnit (nv,ov) {
        this.initData()
      }
    },
    methods: {
      exportReport () {
        this.$router.push('maintenanceReport')
        return
        this.$dialogMethod.showLoading("正在生成报告。。。")
        this.$api.reportApi.exportUnitMonthReportWord(this.nowUnit.id,new Date(new Date().formatByMonth()).getTime()-24*
          60*
          60*1000,respon => {
            if(!respon.includes('%2F')) {
              this.$dialogMethod.showMessage(respon)
              return
            }
            saveAs(DWSystemSetting.downloadUrl+'/'+respon,respon.substring(respon.lastIndexOf('%2F')+3))
            this.$dialogMethod.closeLoading()
          })
      },
      initData () {
        this.$api.unitApi.getKanbanCountInfo(this.nowUnit.id,respon => {
          this.kanbanCountInfo=respon
        })
      }
    }
  }
</script>

<style scoped>
  @import url("../../../components/css/usePowerUnit.css");

  .unitInfoBody {
    height: 274px;
  }

  .columnsContent {
    margin: 20px 10px;
  }

  .unitContent {
    height: calc(100% - 31px);
    overflow: hidden;
  }

  .userInfo {
    width: 45%;
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .userInfo div {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 70%;
    justify-content: space-around;
  }

  .userInfo div p {
    width: 100%;
    height: 5px;
  }

  .userInfo div span {
    font-size: .3rem;
  }

  .userInfo div:nth-child(1) span {
    color: #86e4f5;
  }

  .userInfo div:nth-child(1) p {
    background-color: #86e4f5;
  }

  .userInfo div:nth-child(2) span {
    color: #ff9900;
  }

  .userInfo div:nth-child(2) p {
    background-color: #ff9900;
  }

  .userInfo div:nth-child(3) span {
    color: #0293fc;
  }

  .userInfo div:nth-child(3) p {
    background-color: #0293fc;
  }
</style>